import { useState } from "react";
import { CategoryPicker } from "@/components/CategoryPicker";
import { toast } from "sonner";
import { Tag, UserCog } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

const bulk = async (ids, patch, label, onDone) => {
  try { const { data } = await api.post("/leads/bulk-update", { ids, ...patch }); toast.success(`${label} for ${data.updated} lead(s)`); onDone(); return true; }
  catch (e) { toast.error(errMsg(e)); return false; }
};

export function BulkCategory({ ids, onDone }) {
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState([]);
  const go = async (mode) => { if (await bulk(ids, { business_categories: val, mode }, mode === "add" ? "Categories added" : "Categories replaced", onDone)) { setOpen(false); setVal([]); } };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><Button size="sm" variant="outline" className="bg-white" data-testid="bulk-category-btn"><Tag size={14} className="mr-1" />Set category</Button></PopoverTrigger>
      <PopoverContent className="w-80 p-3 space-y-2" align="end">
        <CategoryPicker value={val} onChange={setVal} testid="bulk-category-picker" />
        <div className="flex gap-2">
          <Button size="sm" className="flex-1" disabled={!val.length} onClick={() => go("add")} data-testid="bulk-category-add">Add to {ids.length}</Button>
          <Button size="sm" variant="outline" className="flex-1" onClick={() => go("replace")} data-testid="bulk-category-replace">{val.length ? "Replace" : "Clear"} on {ids.length}</Button>
        </div>
        <p className="text-[11px] text-slate-500">Add keeps existing categories. Replace overwrites them.</p>
      </PopoverContent>
    </Popover>
  );
}

export function BulkOwner({ ids, users, onDone }) {
  return (
    <Select value="" onValueChange={(v) => bulk(ids, { owner_id: v }, `Owner set to ${users.find((u) => u.id === v)?.name}`, onDone)}>
      <SelectTrigger className="h-9 w-40 bg-white" data-testid="bulk-owner-select"><UserCog size={14} className="mr-1" /><SelectValue placeholder="Assign owner…" /></SelectTrigger>
      <SelectContent>{users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}</SelectContent>
    </Select>
  );
}
